import useTable from '../../../hooks/useTable';
import { Table } from '../../Table';
import { TableComponentProps } from '../types';

const columnLables = {
  unsecured_cash_borrowing: {
    name: 'Unsecured cash borrowing',
    order: 225,
    letter: 'A'
  },
  secured_borrowing_prime_brokerage: {
    name: 'Collateralised/secured cash borrowing - via Prime Broker',
    order: 226,
    letter: 'A'
  },
  secured_borrowing_reverse_repo: {
    name: 'Collateralised/secured cash borrowing - via (reverse) repo',
    order: 227,
    letter: 'A'
  },
  secured_borrowing_other: {
    name: 'Collateralised/secured cash borrowing - via Other',
    order: 228,
    letter: 'A'
  }
};

export function Borrowing({
  funds,
  onChangeFund,
  currentDataKey,
  schema,
  isStaticTemplate,
  isMultiFunds
}: TableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useTable({
    data: funds[currentDataKey]?.fund_data?.BORROWING_DETAILS,
    onChangeFund,
    schema: schema.BORROWING_DETAILS,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.BORROWING_DETAILS?.field_names || [],
    columnLables,
    tableName: 'BORROWING_DETAILS',
    funds,
    isMultiFunds
  });

  return (
    <Table
      id="fca-reporttables-borrowing-table"
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
      handleChanges={onChange}
      columns={columns}
      rows={rows}
    />
  );
}
